var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0026 1.66602C8.24598 1.66593 6.56032 2.35915 5.31197 3.59501C4.06363 4.83087 3.3535 6.50948 3.33594 8.26602C3.33594 12.8327 9.21094 17.916 9.46094 18.1327C9.61188 18.2618 9.80398 18.3327 10.0026 18.3327C10.2012 18.3327 10.3933 18.2618 10.5443 18.1327C10.8359 17.916 16.6693 12.8327 16.6693 8.26602C16.6517 6.50948 15.9416 4.83087 14.6932 3.59501C13.4449 2.35915 11.7592 1.66593 10.0026 1.66602ZM10.0026 16.3743C8.61094 15.0493 5.0026 11.3743 5.0026 8.26602C5.0026 6.93993 5.52939 5.66816 6.46707 4.73048C7.40475 3.7928 8.67652 3.26602 10.0026 3.26602C11.3287 3.26602 12.6005 3.7928 13.5381 4.73048C14.4758 5.66816 15.0026 6.93993 15.0026 8.26602C15.0026 11.3493 11.3943 15.0493 10.0026 16.3743Z",
    fill: "#46474C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0026 5C9.42574 5 8.86184 5.17106 8.38219 5.49155C7.90255 5.81203 7.52871 6.26756 7.30796 6.80051C7.0872 7.33346 7.02944 7.9199 7.14198 8.48568C7.25452 9.05146 7.53231 9.57116 7.94021 9.97906C8.34811 10.387 8.86781 10.6648 9.43359 10.7773C9.99937 10.8898 10.5858 10.8321 11.1188 10.6113C11.6517 10.3906 12.1072 10.0167 12.4277 9.53708C12.7482 9.05744 12.9193 8.49353 12.9193 7.91667C12.9193 7.14312 12.612 6.40125 12.065 5.85427C11.518 5.30729 10.7762 5 10.0026 5ZM10.0026 9.16667C9.75538 9.16667 9.5137 9.09336 9.30814 8.956C9.10258 8.81865 8.94237 8.62343 8.84776 8.39502C8.75315 8.16661 8.72839 7.91528 8.77662 7.6728C8.82486 7.43033 8.94391 7.2076 9.11872 7.03278C9.29354 6.85797 9.51627 6.73892 9.75874 6.69068C10.0012 6.64245 10.2526 6.66721 10.481 6.76182C10.7094 6.85643 10.9046 7.01664 11.0419 7.2222C11.1793 7.42777 11.2526 7.66944 11.2526 7.91667C11.2526 8.24819 11.1209 8.56613 10.8865 8.80055C10.6521 9.03497 10.3341 9.16667 10.0026 9.16667Z",
    fill: "#46474C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.a004205b62db894d3acc4859a791e26a.svg";
export { ForwardRef as ReactComponent };